import client from '@yola/ws-service-client';
import serviceClient from '../service-client';
import config from '../../config';
import authActionTypes from '../../auth/constants/action-types';

const clientLoader = (store) => (next) => (action) => {
  switch (action.type) {
    case authActionTypes.SET_TOKEN: {
      const state = store.getState();
      const apiUrl = config.selectors.getServiceAPIUrl(state);

      const { authToken } = action.payload;
      serviceClient.set(client.initWith(apiUrl, authToken));

      next(action);
      break;
    }
    default: {
      next(action);
    }
  }
};

export default clientLoader;
